import { snakeToCamel } from '@/common/converter/utils/snake-to-camel'

export const snakeToCamelObj = (obj) => {
	if (typeof obj !== 'object' || obj === null) {
		return obj
	}

	if (Array.isArray(obj)) {
		return obj.map((item) => snakeToCamelObj(item))
	}

	const camelObj = {}
	Object.keys(obj).forEach((key) => {
		const camelKey = snakeToCamel(key)
		camelObj[camelKey] = snakeToCamelObj(obj[key])
	})

	return camelObj
}
